export default __webpack_public_path__ + "static/media/christmas-tree-border.46190a06.svg";